<template>
  <header>
    <nav>
      <div class="container">
        <div class="menu">
          <a href="http://ow.thnuclub.com"><p class="site">守望先锋音频</p></a>
          <a href="http://ovi.thnuclub.com"><p class="site">守望先锋画廊</p></a>
          <a href="http://hero.thnuclub.com"><p class="site">风暴英雄音频</p></a>
          <a href="#"><p class="site">风暴英雄画廊</p></a>
          <a href="#"><p class="site">炉石传说音频</p></a>
          <a href="#"><p class="site">炉石传说画廊</p></a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'headernav',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
header {
  z-index: 999;
  position  : fixed;
  display   : block;
  height    : 60px;
  width     : 100%;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
  transition: 0.5s;
  &:hover{
    background: rgba(255, 255, 255, 0.95);
    transition: 0.5s
  }
  nav {height: 100%;}
  .container {
    height: 100%;
    .menu {
      display    : flex;
      width      : 960px;
      height     : 100%;
      margin     : auto;
      align-items: center;
      a {
        color: #345;
        text-decoration: none;
        &:visited{color:#345};
      }
      p.site{
        display      : block;
        border-bottom: 3px solid rgba(0, 0, 0, 0);
        padding      : 2px 0px;
        margin       : 4px 12px;
        transition   : all 1.5s;
      }
      p.site:hover{
        color        : rgb(0, 67, 94);
        border-bottom: 3px solid #307fff;
        transition   : all 1s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headernav.vue